module.exports = __webpack_public_path__ + "img/13.8a44267f.png";